import { instance } from "api/apiBase";

interface ZumperStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/zumper";

export const zumperApi = {
  getStatus: async (): Promise<ZumperStatusResponse> => {
    const { data } =
      await instance.get<ZumperStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<ZumperStatusResponse> => {
    const { data } =
      await instance.post<ZumperStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  disconnect: async (): Promise<ZumperStatusResponse> => {
    const { data } =
      await instance.delete<ZumperStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
